import axios from "axios";
import * as _ from "lodash";
import log2 from "../utils/log2";

let SOCKET_URL = process.env.SOCKET_URL;
const log = log2("hostFetcher");
const request = axios.create({
    baseURL: SOCKET_URL,
    timeout: 20000, // request timeout
});

const lastSocketServers = {
    servers: [],
    fetchTime: Date.now(),
    failedServers: [],
};

// Rate limiter: 60 saniyede maksimum 12 request (5 saniyede 1 request)
const rateLimiter = {
    requestTimestamps: [],
    maxRequestsPerMinute: 12,
    windowMs: 60000, // 60 saniye
    minIntervalMs: 5000, // 5 saniye minimum interval

    canMakeRequest() {
        const now = Date.now();
        // 60 saniyeden eski timestamp'leri temizle
        this.requestTimestamps = this.requestTimestamps.filter((ts) => now - ts < this.windowMs);

        // Son request'ten bu yana geçen süreyi kontrol et
        const lastRequestTime = this.requestTimestamps[this.requestTimestamps.length - 1];
        if (lastRequestTime && now - lastRequestTime < this.minIntervalMs) {
            const waitTime = this.minIntervalMs - (now - lastRequestTime);
            log.debug("Rate limit: minimum interval not met, need to wait", waitTime, "ms");
            return { allowed: false, waitTime };
        }

        // 60 saniye içindeki request sayısını kontrol et
        if (this.requestTimestamps.length >= this.maxRequestsPerMinute) {
            const oldestTimestamp = this.requestTimestamps[0];
            const waitTime = this.windowMs - (now - oldestTimestamp);
            log.debug("Rate limit: max requests per minute reached, need to wait", waitTime, "ms");
            return { allowed: false, waitTime };
        }

        return { allowed: true, waitTime: 0 };
    },

    recordRequest() {
        this.requestTimestamps.push(Date.now());
    },
};

const isValidResponse = (servers) => {
    const selfHost = servers.find((x) => x.self);
    if (selfHost && selfHost.ready) return true;
    else return false;
};

const performUpdateSocketServers = (force = false) => {
    const rateLimitCheck = rateLimiter.canMakeRequest();
    if (force) {
        rateLimitCheck.allowed = true;
        rateLimitCheck.waitTime = 0;
    }
    if (!rateLimitCheck.allowed) {
        log.warn("Rate limit reached, scheduling next request in", rateLimitCheck.waitTime, "ms");
        // Sekme inactive ise daha uzun bekle
        const isTabVisible = document.visibilityState === "visible";
        const adjustedWaitTime = isTabVisible ? rateLimitCheck.waitTime : Math.max(rateLimitCheck.waitTime, 10000);
        setTimeout(updateSocketServers, adjustedWaitTime);
        return;
    }

    log.debug("updating socket servers");
    rateLimiter.recordRequest();

    request
        .get("/hosts?from=cpanel")
        .then((res) => {
            log.debug("updateSocketServers", res.data);
            const servers = res.data;
            if (isValidResponse(servers)) {
                lastSocketServers.servers = servers;
                lastSocketServers.fetchTime = Date.now();
                lastSocketServers.failedServers = [];
            } else {
                log.warn("Socket Servers is not valid, re-fetch will run in a seconds ");
                setTimeout(updateSocketServers, 5000); // minimum interval'e uygun hale getirildi
            }
        })
        .catch((err) => {
            console.error(err);
            log.error("Socket servers fetch error", { err: err.message });
            setTimeout(updateSocketServers, 5000); // minimum interval'e uygun hale getirildi
        });
};
const updateSocketServers = _.debounce(performUpdateSocketServers, 1000);

updateSocketServers();
let nextCallCount = 0;
const getValidServers = () => {
    const allServers = [...lastSocketServers.servers];
    const failedServers = [...lastSocketServers.failedServers];

    const validServers = _.orderBy(
        allServers.filter((x) => x.ready && !x.circuitBreaker),
        ["cpu.load", "uptime"],
        ["asc", "desc"]
    ).filter((x) => !failedServers.includes(x.instanceId));
    return {
        allServers,
        failedServers,
        validServers,
    };
};
export const getNextSocketServerCandidate = (print) => {
    if (nextCallCount === 0) updateSocketServers();
    nextCallCount++;

    const { allServers, failedServers, validServers } = getValidServers();
    log.debug("validServers", validServers);
    if (print)
        log.debug("getNextSocketServerCandidate", {
            allServers: allServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
            failedServers: failedServers.map((x) => _.takeRight(x, 3).join("")),
            validServers: validServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
        });
    const candidateServer = _.head(validServers);
    if (!candidateServer && allServers.length === failedServers.length && validServers.length === 0) {
        updateSocketServers();
    }

    return candidateServer;
};

export const markFailedSocketServer = (id) => {
    lastSocketServers.failedServers.push(id);
    lastSocketServers.failedServers = _.uniq(lastSocketServers.failedServers);
    log.debug("markFailedSocketServer", id, lastSocketServers.failedServers);
    if (!getNextSocketServerCandidate(true)) {
        updateSocketServers();
    }
};

setInterval(() => {
    const { allServers, failedServers, validServers } = getValidServers();
    const candidateServer = _.head(validServers);
    if (!candidateServer) updateSocketServers();
}, 20 * 1000);

export const socketRequest = request;
(()=>{
    performUpdateSocketServers(true)
})()